import './index.scss';

const blockIframe = () => {
	
};

export default blockIframe;